var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      label: _vm.label,
      items: _vm.collections,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      outlined: _vm.outlined,
      dense: _vm.dense,
      loading: _vm.loading,
      disabled: _vm.disabled,
      "hide-details": _vm.hideDetails,
      "hide-no-data": _vm.hideNoData,
      "background-color":
        _vm.disabled || _vm.loading ? `grey lighten-2` : _vm.backgroundColor,
      error: _vm.error,
      "error-messages": _vm.errorMessages,
      clearable: _vm.clearable,
      multiple: _vm.multiple,
      "small-chips": _vm.smallChips,
    },
    on: {
      focus: function ($event) {
        return _vm.$emit("onClick", true)
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "item",
          fn: function ({ item }) {
            return [
              _vm._t(
                "item",
                function () {
                  return [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", {
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                null,
                { item }
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }